import React from 'react'
import { connect } from 'react-redux'

import { AppState } from 'store/types'

import MainNavigationBar from './MainNavigationBar'

interface Props {
}

const mapStateToProps = ({ session }: AppState) => ({
  userInfo: session.user!.info,
})

type InjectedProps = Props & ReturnType<typeof mapStateToProps>

const MainNavigationBarContainer: React.SFC<InjectedProps> = ({ userInfo }) => (
  <MainNavigationBar
    counters={userInfo.counters}
    accountInfo={{
      avatarUrl: userInfo.user!.photoUrl,
      userName: userInfo.user!.name,
      badgeContent: Number(userInfo.bonusRemainingSec === 0),
      balance: userInfo.user!.balance
    }}
  />
)

export default connect(mapStateToProps)(MainNavigationBarContainer)
try {
    // @ts-ignore
    MainNavigationBarContainer.displayName = "MainNavigationBarContainer";
    // @ts-ignore
    MainNavigationBarContainer.__docgenInfo = { "description": "", "displayName": "MainNavigationBarContainer", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/MainNavigationBar/MainNavigationBarContainer.tsx#MainNavigationBarContainer"] = { docgenInfo: MainNavigationBarContainer.__docgenInfo, name: "MainNavigationBarContainer", path: "src/components/MainNavigationBar/MainNavigationBarContainer.tsx#MainNavigationBarContainer" };
}
catch (__react_docgen_typescript_loader_error) { }